import { get } from './client';
import { ROUTES } from './config';
import type { ApiEnvelope } from '@/types/types';

export interface CatalogEntry {
    id: number;
    service_type: string;
    repair_type?: string | null;
    part?: string | null;
    position?: string | null;
}

export const catalogApi = {
    list: () => get<ApiEnvelope<CatalogEntry[]>>(ROUTES.CATALOG),
};
